import React from 'react';
import '../Process/Process.css';
import Processbox from './Processbox';




function Process() {
  return (
    <div className='process-div' id='process'>
        <h3>The Process</h3>
        <div className='process-sub-div'>
            <Processbox img='images/process-img/ear.png' h5='Listen' text='I take time to understand your requirement.'></Processbox>
            <Processbox img='images/process-img/check-list.png' h5='Plan' text='I plan and design a solution with the best technologies that meet the objectives.'></Processbox>
            <Processbox img='images/process-img/web-development.png' h5='Develop' text='Brings the solution design to life.'></Processbox>
            <Processbox img='images/process-img/rocket.png' h5='Launch' text='On time and my services include post-launch maintenance to ensure everything is working smoothly.'></Processbox>
        </div>
    </div>
  )
}

export default Process